angular.module('cfn').factory('bookingActivitiesService', [
  '$log',
  '$http',
  '$q',
  '$rootScope',
  function($log, $http, $q, $rootScope) {
    'use strict';

    // Private
    var URL = '/365FarmNet/rest/booking/operation_activities/',
      BASE_ACTIVITIES = [
        'TILLING',
        'SOWING',
        'HARVESTING',
        'PLANTPROTECTING',
        'TOFERTILIZE'
      ];
    var activities = null;

    // Load own Activities
    var query = function(reload) {
      if (activities && !reload) return $q.when(activities);
      else
        return $http.get(URL).then(function(response) {
          activities = response.data;
          $rootScope.$broadcast('reloadActivities');
          return activities;
        });
    };

    // Load own Activities
    var reload = function() {
      return query(true);
    };

    var del = function(id) {
      return $http.delete(URL + id).then(function() {
        activities = null;
        return query();
      });
    };

    var save = function(data) {
      app.showLoader();
      return $http.post(URL, data).then(function() {
        app.hideLoader();
        activities = null;
        return query();
      });
    };

    var load = function(id) {
      return $http.get(URL + id);
    };

    var reset = function(id) {
      app.showLoader();
      return $http.post(URL + 'restore_preset').then(function(response) {
        app.hideLoader();
        activities = null;
        $rootScope.$broadcast('reloadActivities');
        return response;
      });
    };

    var isActivity = function(id) {
      return activities.some(function(activity) {
        return activity.id === id;
      });
    };

    var listActivities = function() {
      return query().then(function(activities) {
        function toIndexKey(value) {
          return value ? value.toLowerCase().replace(/\u00AD/g, '') : '';
        }

        //object with indexed name as key (lowercase)
        var baseActivitiesNames = _.reduce(
          BASE_ACTIVITIES,
          function(obj, activity) {
            obj[toIndexKey(enums.BookingActivitiesEnum[activity])] = {
              id: null,
              //remove soft hyphen
              templateName: enums.BookingActivitiesEnum[activity],
              activity: activity
            };
            return obj;
          },
          {}
        );

        _.each(activities, function(activity) {
          //"supply" activity type is one of SOWING/TOFERTILIZE/PLANTPROTECTANT returned here as UNKNOWN
          var activityName =
            activity.icon === 'SUPPLY' ? 'UNKNOWN' : activity.icon;
          baseActivitiesNames[toIndexKey(activity.name)] = {
            id: activity.id,
            templateName: activity.name,
            activity: activityName
          };
        });
        return _.sortBy(_.values(baseActivitiesNames), 'templateName');
      });
    };

    // Public
    return {
      query: query,
      init: reload,
      reload: reload,
      reset: reset,
      del: del,
      load: load,
      save: save,
      isActivity: isActivity,
      /** list user activities extended by some basic ones, if they are not already present */
      listActivities: listActivities
    };
  }
]);
